import { createBrowserHistory } from "history";
import {applyMiddleware, combineReducers, compose, createStore} from "redux";
import {dataReducer} from "./reducers";
import {configureStore} from "@reduxjs/toolkit";

//export const history = createBrowserHistory();

export default function configureCustomStore(preloadedState) {
  // const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  //   ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  //       trace: true,
  //       traceLimit: 25
  //     })
  //   : compose;
  const store = configureStore({
        reducer: combineReducers({data: dataReducer})
      }
  );

  // Hot reloading
  // if (module.hot) {
  //   // Enable Webpack hot module replacement for reducers
  //   module.hot.accept("./reducers", () => {
  //     store.replaceReducer(createRootReducer(history));
  //   });
  // }

  return store;
}
